const { ArrowCircleRightOutlined } = require("@mui/icons-material");
const { Button, CircularProgress } = require("@mui/material")
const { useTranslation } = require("react-i18next")

const IndieNextStepButton = ({label, loading, ...params}) => {
    const { t } = useTranslation();
    return <Button startIcon={loading ? <CircularProgress color="inherit" size={18} /> : <ArrowCircleRightOutlined/>} variant="outlined" {...params}>{label ? label : t("label.button.next")}</Button>
}

export default IndieNextStepButton;